// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"5a34a448","59":"bbeaf53f","155":"ec8d4e45","245":"6611bd82","288":"f6e725ed","395":"bfbfef53","454":"1fd5604a","507":"35081924","536":"e60b3db0","549":"79c95404","564":"8d266b8d","574":"60a93010","599":"e1f99e40","683":"a7a8c053","858":"c5c74fb6"}[chunkId] + ".chunk.js";
};